import { useFormikContext } from "formik";
import { useState, useEffect } from "react";

import dayjs from "dayjs";
import PassportField from "./upload-passport/input-field";

import { useTranslation } from "i18n";
import { monthsLong } from "utils/Utils";

const ImageInput = ({
  index,
  setErrImg,
  departureDate,
  hasProgress,
  onFilled,
}) => {
  const { t } = useTranslation();
  const { setFieldValue, setFieldError, values, errors } = useFormikContext();

  const [score, setScore] = useState();

  useEffect(() => {
    if (
      values[`documents${index}`] &&
      values[`documents${index}`]?.length > 0
    ) {
      const documents = values[`documents${index}`];
      documents[0].expiryDate =
        values["expDateYear" + index] +
        "-" +
        (values["expDateMonth" + index]?.length === 2
          ? values["expDateMonth" + index]
          : monthsLong[values["expDateMonth" + index]]) +
        "-" +
        values["expDateDay" + index];
      setFieldValue(`documents${index}`, documents);
    }
  }, [values]);

  const handlePassportResponse = (travelerData) => {
    const date = travelerData?.birthDate?.split("-");
    const documents = [
      {
        number: travelerData?.documentNumber,
        expiryDate: travelerData?.expirationDate,
        issuanceCountry: travelerData?.issuingState,
        nationality: travelerData?.nationality,
        documentType: "PASSPORT",
        holder: true,
      },
    ];
    setFieldValue(`firstName${index}`, travelerData?.firstName);
    setFieldValue(`lastName${index}`, travelerData?.lastName);
    setFieldValue(`gender${index}`, travelerData?.sex?.toUpperCase());
    if (travelerData?.birthDate) {
      setFieldValue(`dateOfBirthYear${index}`, date[0]);
      setFieldValue(`dateOfBirthMonth${index}`, date[1]);
      setFieldValue(`dateOfBirthDay${index}`, date[2]);
    }

    setScore(travelerData?.score);

    setFieldValue(
      `expDateDay${index}`,
      dayjs(travelerData?.expirationDate).format("DD")
    );
    setFieldValue(
      `expDateMonth${index}`,
      dayjs(travelerData?.expirationDate).format("MM")
    );
    setFieldValue(
      `expDateYear${index}`,
      dayjs(travelerData?.expirationDate).format("YYYY")
    );
    setFieldValue(`docNumber${index}`, travelerData?.documentNumber);
    setFieldValue(`documents${index}`, documents);
    onFilled?.();

    const expiryDate = dayjs(travelerData?.expirationDate);
    const depDate = dayjs(departureDate);
    const sixMonthsAfterDeparture = depDate.add(6, "months");

    if (expiryDate.isBefore(sixMonthsAfterDeparture)) {
      setFieldError(
        `expDateYear${index}`,
        t("booking.existingTravelers.expirationInvalid"),
      );
    }
  };

  const confidence = Math.max(0, Math.min(100, Number(score) || 0));
  const level = confidence >= 80 ? "high" : confidence >= 45 ? "medium" : "low";

  return (
    <>
      <PassportField
        setErrImg={setErrImg}
        handlePassportResponse={handlePassportResponse}
      />

      {hasProgress && score != null && (
        <div className="pp-confidence" data-level={level}>
          <div className="pp-confidence-head">
            <span>{t("booking.labels.scanConfidence")}</span>
            <strong>{Math.round(confidence)}%</strong>
          </div>
          <div className="pp-confidence-track">
            <div
              className="pp-confidence-fill"
              style={{ width: `${confidence}%` }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageInput;
